import React, { useEffect, useState } from "react";
import { IoIosArrowRoundForward } from "react-icons/io";
import Pageslide from "../../commanfile/Pageslide";
// import image1 from "../../Images/hospital1.jpg"
// import image2 from "../../Images/hospital2.jpg";
// import image3 from "../../Images/hospital3.jpg";
// import image4 from "../../Images/hospital4.jpg";
// import image5 from "../../Images/hospital5.jpg";
// import image6 from "../../Images/hospital6.jpg";
// import image7 from "../../Images/hospital7.jpg";
// import image8 from "../../Images/hospital8.jpg";
// import image9 from "../../Images/hospital9.jpg";
import pageslides from "../../Images/original.png";
import axios from "axios";


// const photos = [
//   {
//     imag: image1,
//   },
//   {
//     imag: image2,
//   },
//   {
//     imag: image3,
//   },
//   {
//     imag: image4,
//   },
//   {
//     imag: image5,
//   },
//   {
//     imag: image6,
//   },
//   {
//     imag: image7,
//   },
//   {
//     imag: image8,
//   },
//   {
//     imag: image9,
//   },

// ];
const Photos = () => {
  const [selectedImage, setSelectedImage] = useState([]);

  const handleFetchUserData = async () => {
    try {
      const result = await axios.get(`https://psynexa-backend.onrender.com/fetch/gallaryImage`);

      setSelectedImage(result.data.data)

    } catch (error) {
      console.log(error.massage);
    }
  };

  useEffect(() => {
    handleFetchUserData()
  }, [])

  return (
    <>

      <div className="max-w-[1456px] mx-auto ">
        <div className="mx-auto">
          <Pageslide name={"Gallary"} imgaes={pageslides}
            className={"w-[100%] lg:h-[750px] pt-3 sm:w-[100%] opacity-35"} />
        </div>

        <div className="min-h-screen bg-gray-100 py-10 px-4">

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {selectedImage.map((src, index) => (
              <div
                key={index}
                className="overflow-hidden rounded-lg shadow hover:shadow-lg transition-shadow cursor-pointer"
              >
                <img
                  src={`https://psynexa-backend.onrender.com/${src.Gallary_Image}`}

                  className="w-full h-60 object-cover transform hover:scale-105 transition-transform duration-300"
                />
              </div>
            ))}
          </div>


          {/* {selectedImage && (
            <div
              className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
              onClick={() => setSelectedImage(null)}
            >
              <img
                src={selectedImage}
                alt="Enlarged"
                className="max-w-full max-h-[90vh] rounded-lg shadow-lg"
              />
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute top-5 right-5 text-white text-3xl font-bold"
              >
                &times;
              </button>
            </div>
          )} */}
        </div>
      </div>
    </>
  );
};

export default Photos;
